import {
  fetchPanelParticipationStatus,
  getSelectedCustomer,
} from '@/app/slices/userSlice';
import { nackaUser } from '@/helpers/customerUtils';
import { State } from '@/types/State';
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

const usePanelParticipation = () => {
  const selectedCustomer = useSelector((state: State) =>
    getSelectedCustomer(state),
  );
  const customerNumber =
    selectedCustomer?.customerAccounts?.[0]?.customerNumber;
  const query = ['panelParticipationStatus', customerNumber];
  const { data, isLoading, isError } = useQuery({
    queryKey: query,
    queryFn: async () => {
      if (customerNumber) {
        const result = await fetchPanelParticipationStatus(
          customerNumber,
          nackaUser(selectedCustomer),
        );
        return result;
      }
      return false;
    },
  });

  return {
    query,
    data,
    isLoading,
    isError,
  };
};

export default usePanelParticipation;
